import { Table as AntTable } from 'antd';
import styled from 'styled-components';
import { COLORS, STYLES } from 'utils/constants/styles';

const StyledTable = styled(AntTable)`
    width: 100%;
    .ant-table {
        overflow: auto;
        background: transparent;
    }

    .ant-table-thead {
        background: ${props => props.theme.background.table} !important;
        border-radius: ${STYLES.BORDER_RADIUS};
    }

    .ant-table-thead > tr > th {
        color: ${props => props.theme.text.black};
        background: transparent !important;
        word-break: keep-all;
    }

    .ant-table-tbody > tr > td,
    .ant-table-thead > tr > th {
        text-align: center;
        border: none;

        div {
            display: flex;
            justify-content: center;
        }

        &:first-child {
            border-top-left-radius: ${STYLES.BORDER_RADIUS};
            border-bottom-left-radius: ${STYLES.BORDER_RADIUS};
        }

        &:last-child {
            border-top-right-radius: ${STYLES.BORDER_RADIUS};
            border-bottom-right-radius: ${STYLES.BORDER_RADIUS};
        }
    }

    .ant-table-thead > tr > th:first-child {
        border-top-left-radius: ${STYLES.BORDER_RADIUS} !important;
        border-bottom-left-radius: ${STYLES.BORDER_RADIUS} !important;
    }

    .ant-table-thead > tr > th:last-child {
        border-top-right-radius: ${STYLES.BORDER_RADIUS} !important;
        border-bottom-right-radius: ${STYLES.BORDER_RADIUS} !important;
    }

    .ant-table-tbody > tr > td {
        border-bottom: none;
        background: transparent;
    }

    .ant-table-tbody > tr.ant-table-row:hover > td,
    .ant-table-tbody > tr.ant-table-row:hover > td {
        background: unset;
        cursor: pointer;
    }

    .ant-table-container {
        min-width: max-content;
    }

    .ant-pagination-simple-pager {
        input {
            border-radius: ${STYLES.BORDER_RADIUS};
        }
    }

    .selected-row {
        background-color: ${props => props.theme.background.theme || COLORS.BUTTON_BACKGROUND};
    }
`;

export default StyledTable;
